import { useCallback, useState } from 'react'

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

interface UseLockedExpansionConfig {
  readonly expandableKeys: ReadonlySet<string>
  readonly initialExpansion: Record<string, boolean>
}

interface UseLockedExpansionReturn {
  readonly isExpanded: (key: string) => boolean
  readonly onToggle: (key: string) => void
}

export function useLockedExpansion(config: UseLockedExpansionConfig): UseLockedExpansionReturn {
  const { expandableKeys, initialExpansion } = config

  const [expansion, setExpansion] = useState<Record<string, boolean>>(initialExpansion)

  const isExpanded = useCallback((key: string): boolean => expansion[key] ?? false, [expansion])

  const onToggle = useCallback(
    (key: string): void => {
      if (!expandableKeys.has(key)) return
      setExpansion((prev) => ({ ...prev, [key]: !prev[key] }))
    },
    [expandableKeys],
  )

  return { isExpanded, onToggle }
}
